import React from "react";
import { Star } from "lucide-react";

const GoogleLogo = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path
      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.56c2.08-1.92 3.28-4.74 3.28-8.1Z"
      fill="#4285F4"
    />
    <path
      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.56-2.77c-.99.66-2.25 1.06-3.72 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z"
      fill="#34A853"
    />
    <path
      d="M5.84 14.1A6.6 6.6 0 0 1 5.5 12c0-.73.13-1.44.34-2.1V7.07H2.18A11 11 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.83Z"
      fill="#FBBC05"
    />
    <path
      d="M12 5.38c1.62 0 3.07.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.83C6.71 7.31 9.14 5.38 12 5.38Z"
      fill="#EA4335"
    />
  </svg>
);

const RATING = 4.9;
const REVIEW_COUNT = 87;

export const GoogleReviewsBadge = ({ compact = false }) => {
  const stars = Array.from({ length: 5 }).map((_, i) => {
    const full = i + 1 <= Math.floor(RATING);
    const half = !full && i + 0.5 < RATING;
    return (
      <span key={i} className="relative inline-block w-4 h-4">
        <Star size={16} className="text-slate-200" fill="currentColor" strokeWidth={0} />
        {(full || half) && (
          <span
            className="absolute inset-0 overflow-hidden text-amber-400"
            style={{ width: full ? "100%" : "50%" }}
          >
            <Star size={16} fill="currentColor" strokeWidth={0} />
          </span>
        )}
      </span>
    );
  });

  if (compact) {
    return (
      <a
        href="https://www.google.com/search?q=Dila+Group+BV+Antwerpen+reviews"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="google-reviews-badge-compact"
        className="inline-flex items-center gap-2.5 rounded-full bg-white border border-slate-200 px-4 py-2 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all"
      >
        <GoogleLogo className="w-4 h-4" />
        <span className="flex items-center gap-1">{stars}</span>
        <span className="font-display font-bold text-sm text-[#0F172A]">{RATING.toFixed(1)}</span>
        <span className="text-xs text-slate-500 hidden sm:inline">/ {REVIEW_COUNT} reviews</span>
      </a>
    );
  }

  return (
    <section
      id="rating"
      data-testid="google-reviews-section"
      className="py-10 bg-white border-y border-slate-100"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <a
          href="https://www.google.com/search?q=Dila+Group+BV+Antwerpen+reviews"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="google-reviews-badge-full"
          className="group flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-8 text-center sm:text-left"
        >
          <div className="flex items-center gap-3">
            <GoogleLogo className="w-9 h-9" />
            <span className="font-display font-bold text-xl text-[#0F172A]">
              Google Reviews
            </span>
          </div>

          <div className="hidden sm:block h-10 w-px bg-slate-200" />

          <div className="flex items-center gap-3">
            <span className="font-display text-4xl font-extrabold text-[#0F172A] leading-none">
              {RATING.toFixed(1)}
            </span>
            <div>
              <div className="flex items-center gap-0.5">{stars}</div>
              <p className="text-xs text-slate-500 mt-1">
                Gebaseerd op <strong>{REVIEW_COUNT}+</strong> reviews
              </p>
            </div>
          </div>

          <div className="hidden sm:block h-10 w-px bg-slate-200" />

          <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#0284C7] group-hover:text-[#0369A1]">
            Bekijk alle reviews →
          </span>
        </a>
      </div>
    </section>
  );
};
